import { Navigate } from "react-router-dom";
import CustomerDashboardSearch from "../pages/Dashboard/CustomerDashboardList";
import SearchDetailed from "../pages/Dashboard/SearchDetailed";
import UserProfile from "../pages/Dashboard/UserProfile";
import UserProfileEditUser from "../pages/Dashboard/UserProfileEditUser";
import AddMcAdminUser from "../pages/Dashboard/AddMcAdminUser";

export function PrivateRoute({ children }) {
  const getToken = localStorage.getItem("portal_key");
  const token = (getToken);

 
  return token != null ? children : <Navigate to="/" />;
}

  export const privateRoutes = [
  
      {
        route: "/dashboard/search-results",
        component: <CustomerDashboardSearch />,
      },
      {
        route: "/dashboard/search-detailed/:id",
        component: <SearchDetailed />,
      },
      {
        route: "/dashboard/user-profile",
        component: <UserProfile />,
      },
      {
        route: "/dashboard/create-admin-user",
        component: <AddMcAdminUser />,
      },
      {
        route: "/dashboard/user-profile-edit-user/:id",
        component: <UserProfileEditUser />,
      },
     
  ];
